<template>
	<router-link :to="familyuser ? '/family/' + (typeof familyuser.family === 'object' ? familyuser.family : familyuser.family.id) : '#'" class="text-secondary">
		<img alt="" :src="image || (familyuser ? familyuser.avatar : undefined) || '/network/static/img/default.jpg'" class="avatar" :title="familyuser && familyuser.name"> <span v-if="showName">{{ familyuser && familyuser.name }}</span>
	</router-link>
</template>

<script>
module.exports = {
	name: 'c-uavatar',
	props: ['familyuser', 'image', 'showName']
};
</script>



// WEBPACK FOOTER //
// c-uavatar.vue?032f6f5b